


































































































































































import {Vue, Component, Prop, Ref, Watch} from 'vue-property-decorator'
import {Getter, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {FormRowWings, SmsTextInputWings, SelectWings, InputWings} from 'wings-ui-components';
import {MsgTransports} from '@/store/types';
import {EmailTemplateItemImpl} from '@/store/templates/types';
import {notifyError} from '@/utils/notify-helper';
import {readFileAsBinary} from "@/utils/download-helper"
import {cloneDeep} from "lodash";
import EmailPreviewDialog from '@/components/Email/EmailPreviewDialog.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericTemplate, FormRowWings, SmsTextInputWings, SelectWings, EmailPreviewDialog, InputWings}})
export default class EmailTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Ref('ckeditor') ckeditor: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private transport: MsgTransports = MsgTransports.EMAIL;
  private templateObject: EmailTemplateItemImpl = new EmailTemplateItemImpl();

  private fileSizeLimit = 26214400 /* 25 Megabyte */
  private tagRule: object = {
    indent: true,
    breakBeforeOpen: false,
    breakAfterOpen: false,
    breakBeforeClose: false,
    breakAfterClose: false
  }
  private editorConfig: object = {
    allowedContent: true,
    fullPage: true,
    language: this.$i18n.locale,
  }
  private editorUrl = `${process.env.BASE_URL}ckeditor/ckeditor.js`

  isShowEmail = false
  emailContent = null

  specialUnsubscribeRuleList = [
    'do-not-unsubscribe',
    'all',
    'template',
    'message-type',
  ]
  unsubscribeRuleList = [
    'all',
    'template',
    'message-type',
  ]
  subscribeRuleList= [
    'all',
    'template',
    'message-type',
  ]

  showEmail() {
    this.emailContent = this.template.message
    this.isShowEmail = true
  }

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  @Watch('template.unsubscribeLinksRegex', {immediate: true})
  onUnsubscribeLinksRegex(val: string, oldVal?: string) {
    if (!val) {
      this.template.unsubscribeRule = undefined
    }
  }

  @Watch('template.subscribeLinksRegex', {immediate: true})
  onSubscribeLinksRegex(val: string, oldVal?: string) {
    if (!val) {
      this.template.subscribeRule = undefined
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    this.genericTemplate.beforeLeave(to, from, next)
  }

  onEditorReady(ev: any) {
    // The character sequence to be used for line breaks. Default is '\n'
    ev.dataProcessor.writer.lineBreakChars = '';
    ev.dataProcessor.writer.setRules('p', this.tagRule);
    ev.dataProcessor.writer.setRules('span', this.tagRule);
    ev.dataProcessor.writer.setRules('div', this.tagRule);
    // ev.insertText('');
    this.genericTemplate.template.message = this.genericTemplate.template.message.replace(/\n/ig, '')
    this.genericTemplate.templateSaved.message = this.genericTemplate.template.message;
  }

  onEditorInput(ev: any) {
    this.ckeditor.instance.insertText(ev);
  }

  selectFile() {
    const fileInputElement: any = this.$refs.file;
    fileInputElement?.click();
  }

  async onSelectAttach(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    if (!files.length) return

    let fileSizes: number = this.genericTemplate.template.attachedFiles
          .map((f: any) => f.fileData)
          .map((f: any) => f.length * (3 / 4) - 2)
          .reduce((a: number, b: number) => a + b, 0)

    this.$store.commit("setLoading", true);
    for (const file of files) {
      fileSizes += file.size
      if (fileSizes >= this.fileSizeLimit) {
        notifyError(null, null, this.$t('emailAttachedFilesSizeLimit', {filename: file.name}).toString())
        this.$store.commit("setLoading", false);
        return
      }
      this.genericTemplate.template.attachedFiles?.push({
        name: file.name,
        fileData: btoa(await readFileAsBinary(file)),
      });
      this.$store.commit("setLoading", false);
    }
  }

  onDeleteAttach(file: any) {
    this.genericTemplate.template.attachedFiles =
        this.genericTemplate.template.attachedFiles?.filter((att: any) => att.name !== file.name)
  }
}
